import * as R from "ramda";
import TiliaAPIError from "./TiliaAPIError";
import { logInfo } from "api/accounts-customer.js";

export const METHODS = {
  DELETE: "DELETE",
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
};

const millisecondsToNanoseconds = (time) => {
  const factor = 1000000;
  return Math.round(time * factor);
};

export const assertOk = (response, oks = [], data = null) => {
  if (!response.ok) {
    if (!R.contains(response.status, oks)) {
      throw new TiliaAPIError(response, { data });
    }
  }
};

export const assertResponseBodySuccess = (body) => {
  if (body.status === "Failure") {
    throw new Error(body?.payload?.error, { cause: body.codes });
  }
};

export const generateHeaders = (ctx = {}) => {
  return {
    accept: "application/json, text/plain, */*",
    authorization: `Bearer ${R.defaultTo("", R.prop("jwt", ctx))}`,
    "content-type": "application/json;charset=utf-8",
  };
};

export const generateProxyRequest = (ctx, body) => {
  return {
    body: JSON.stringify(body),
    credentials: "include",
    headers: generateHeaders(ctx),
    method: METHODS.POST,
    mode: "cors",
  };
};

export const logExternalApiRequest = async (
  eventName,
  ctx,
  url,
  method,
  statusCode,
  duration // in nanoseconds
) => {
  // eslint-disable-next-line turbo/no-undeclared-env-vars
  if (process.env.JEST_WORKER_ID !== undefined || process.env.VITEST) { // TODO: remove jest check when test migration is complete
    return;
  }

  const hostParts = new RegExp("^([^.]+).(.*)$");
  const idTokens = new RegExp(
    // UUID, UUID without hyphens, or TUID
    "([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}|[0-9a-f]{32}|[a-z]{2,8}_[a-zA-Z0-9]{27})",
    "g"
  );

  const urlObj = new URL(url);

  const parts = hostParts.exec(urlObj.host);

  const ids = {};
  let idIndex = 1;
  const path = urlObj.pathname.replaceAll(idTokens, (match) => {
    const key = `id_${idIndex++}`;
    ids[key] = match;
    return key;
  });

  const logObject = {
    evt: {
      name: `profile-${eventName}`,
    },
    http: {
      url,
      status_code: statusCode,
      method,
      url_details: {
        host: urlObj.host,
        service: parts[1],
        path,
        ids,
        queryString: Object.fromEntries(urlObj.searchParams),
      },
    },
    duration: Number(duration),
    timestamp: new Date().toISOString(),
  };
  logInfo(ctx, logObject);
};

export const proxyFetch = (destination) => async (ctx, path, method, payload) => {
  const start = window.performance.now();

  const url = `${destination}${path}`;

  const response = await fetch(
    "/ui/api/auth/proxy",
    generateProxyRequest(ctx, {
      proxy_uri: url,
      proxy_method: method,
      proxy_payload: payload || undefined,
    })
  );
  const end = window.performance.now();

  logExternalApiRequest(
    "api",
    ctx,
    url,
    method,
    response.status,
    millisecondsToNanoseconds(end - start)
  );

  return response;
};
